import {useCallback, useState} from 'react';
import {useDispatch} from 'react-redux';

import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import Modal, {useModal} from '@stencil/hotels-modal-component';

// Components
import HomeStayGallery from '../../../../../stories/components/hotels/DetailsPageUnif/HomeStaySpaces/HomeStayGallery/HomeStayGallery';
import HomeStaySpacesUI from '../../../../../stories/components/hotels/DetailsPageUnif/HomeStaySpaces/HomeStaySpacesUI';

// types
import {PrivateSpace, SharedSpaces} from '@stencil/hotels-types/src/details-cg/types';

interface HomeStaySpacesProps {
  privateSpaces: PrivateSpace[];
  sharedSpaces: SharedSpaces[];
  propertyLayoutTitleText: string;
  roomType: string;
}

const HomeStaySpaces = ({
  privateSpaces = [],
  sharedSpaces = [],
  propertyLayoutTitleText = '',
  roomType = '',
}: HomeStaySpacesProps) => {
  const dispatch = useDispatch();
  const {
    isModalOpen: isModalOpenGallery,
    closeModal: closeModalGallery,
    openModal: openModalGallery,
  } = useModal();
  const [modalSelectedImage, setModalSelectedImage] = useState(null);

  const handlerOnClickRoomCard = useCallback(
    (item, isPrivateSpace) => {
      openModalGallery();
      setModalSelectedImage(item);
      dispatch(
        omnitureThunk(omnitureConfig.pages.Details, omnitureConfig.events.ctaClick, {
          cta: {
            name: `propertyLayoutClicked_${isPrivateSpace ? 'Private' : 'Shared'}_${
              item?.name || ''
            }`,
          },
        }),
      );
    },
    [omnitureThunk, openModalGallery, omnitureConfig],
  );

  if (!privateSpaces?.length && !sharedSpaces?.length) {
    return null;
  }

  return (
    <>
      <HomeStaySpacesUI
        sharedSpaces={sharedSpaces}
        privateSpaces={privateSpaces}
        handlerOnClickRoomCard={handlerOnClickRoomCard}
        propertyLayoutTitleText={propertyLayoutTitleText}
        roomType={roomType}
      />
      <Modal
        isOpen={isModalOpenGallery}
        closeModal={closeModalGallery}
        modalStyles={{
          width: '108rem',
          height: '59rem',
        }}
        hideCloseButton
      >
        <HomeStayGallery
          closeModal={closeModalGallery}
          privateSpaces={privateSpaces}
          sharedSpaces={sharedSpaces}
          modalSelectedImage={modalSelectedImage}
        />
      </Modal>
    </>
  );
};

export default HomeStaySpaces;
